import { useEffect } from 'react';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ 
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.08,
  easing: 'ease',
  speed: 500
});

const TopLoadingBar = () => {
  useEffect(() => {
    NProgress.start();
    
    return () => {
      NProgress.done();
    };
  }, []);

  return null;
};

export default TopLoadingBar;

